<template>
  <div>
    <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <div class="hs-screen-box">
        <div>活动开支统计</div>
        <div>
          <ButtonGroup>
          </ButtonGroup>
        </div>
      </div>
      <Row>

        <Col span="5">
          <Card :bordered="false">
            <div style="text-align:center">
              <h1>{{ amountData.totalAmount }}</h1>
              <span>总支出金额</span>
            </div>
          </Card>
        </Col>
        <Col span="5" offset="1">
          <Card :bordered="false">
            <div style="text-align:center">
              <h1>{{ amountData.registerAmount }}</h1>
              <span>新用户注册支出总金额</span>
            </div>
          </Card>
        </Col>
        <Col span="5" offset="1">
          <Card :bordered="false">
            <div style="text-align:center">
              <h1>{{ amountData.orderAmount }}</h1>
              <span>下单支出总金额</span>
            </div>
          </Card>
        </Col>
        <Col span="5" offset="1">
          <Card :bordered="false">
            <div style="text-align:center">
              <h1>{{ amountData.vipAmount }}</h1>
              <span>开通VIP支出总金额</span>
            </div>
          </Card>
        </Col>
      </Row>
    </Card>

    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <div class="hs-screen-row">
        <Input v-model="params.nickName" placeholder="昵称" clearable style="width: 200px"/>
      </div>
      <div class="hs-screen-row">
        <Button type="primary" @click="findList">查询</Button>
      </div>
      <div class="hs-screen-row">
        <Button @click="resetScreen">重置</Button>
      </div>
    </Card>

    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <!--标题-->
      <div slot="title">
        <div class="hs-screen-box">
          <div>活动奖励明细</div>

          <div>
            <ButtonGroup>
              <div style="margin-left: 0">
                推广活动：
                <i-switch v-model="switch1" @on-change="change" />
              </div>
            </ButtonGroup>
          </div>
        </div>
      </div>
      <!--表格数据-->
      <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">

        <template slot-scope="{ row, index}" slot="isVip">
          <Tag color="green" v-if="row.isVip === 0" size="default">否</Tag>
          <Tag color="volcano" v-if="row.isVip === 1" size="default">是</Tag>
        </template>

        <template slot-scope="{ row, index}" slot="inviteeIsVip">
          <Tag color="green" v-if="row.inviteeIsVip === 0" size="default">否</Tag>
          <Tag color="volcano" v-if="row.inviteeIsVip === 1" size="default">是</Tag>
        </template>
<!--        <template slot-scope="{ row, index}" slot="changeType">-->
<!--          <Tag color="green" v-if="row.changeType === 1" size="default">否</Tag>-->
<!--          <Tag color="volcano" v-if="row.changeType === 2" size="default">是</Tag>-->
<!--          <Tag color="volcano" v-if="row.changeType === 3" size="default">是</Tag>-->
<!--          <Tag color="volcano" v-if="row.changeType === 4" size="default">是</Tag>-->
<!--        </template>-->

<!--        <template slot-scope="{ row }" slot="action">-->
<!--          <Button type="success" size="small" style="margin-right: 5px" @click="showInvitation(row)">下级用户-->
<!--          </Button>-->
<!--        </template>-->
      </Table>
      <!--分页-->
      <div class="hs-page">
        <Page :total="total" show-sizer show-total transfer @on-change="changePage"
              @on-page-size-change="changePageSize"/>
      </div>
    </Card>

    <activity-ope ref="activityOpe" @changeDate="findList"></activity-ope>

    <invitee-ope ref="inviteeOpe" @changeDate="findList"></invitee-ope>
  </div>
</template>

<script>
import hsBreadcrumb from '@/components/hs-breadcrumb';
import activityOpe from './components/activity-ope.vue';
import inviteeOpe from './components/invitee-ope.vue';

export default {
  data() {
    return {
      total: 0,
      dateInit: '',
      isTableLoading: false,
      // 参数
      params: {
        page: 1,
        rows: 10,
        username: '',
        nickName: '',
        level: '',
        startTime: '',
        endTime: '',
        isDisable: '',
      },
      // 表格列
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: '用户ID',
          minWidth: 120,
          key: 'userId'
        },
        {
          title: '昵称',
          minWidth: 180,
          key: 'nickName'
        },
        {
          title: '星标用户',
          minWidth: 180,
          slot: 'isVip'
        },
        {
          title: '被邀请人ID',
          minWidth: 180,
          key: 'inviteeId'
        },
        {
          title: '被邀请人',
          minWidth: 180,
          key: 'inviteeNickName'
        },
        {
          title: '星标用户（被邀请人）',
          minWidth: 180,
          slot: 'inviteeIsVip'
        },
        {
          title: '奖励类型',
          minWidth: 180,
          key: 'title'
        },
        {
          title: '奖励金额（元）',
          minWidth: 180,
          key: 'changeAmount'
        },
        {
          title: '回收订单号',
          minWidth: 180,
          key: 'orderCode'
        },
        {
          title: '创建时间',
          minWidth: 180,
          key: 'createTime'
        },
        // {
        //   title: '操作',
        //   slot: 'action',
        //   width: 180,
        //   align: 'center'
        // }
      ],
      // 表格数据
      data: [],
      // 面包屑
      breadcrumb: [
        {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
        {name: '用户管理', url: '', icon: '', size: 0},
        {name: '活动明细', url: '', icon: '', size: 0}
      ],
      amountData: {
        totalAmount: 0,
        orderAmount: 0,
        vipAmount: 0,
        registerAmount: 0
      },
      switch1: false
    }
  },
  created() {
    // 用户-列表查询
    this.findList();
    // 统计活动开支
    this.getActivityAmount()
    // 查询配置接口
    this.getConfigKey();
  },
  methods: {
    // 用户-列表查询
    findList() {
      this.isTableLoading = true;
      this.axios.post('/activityUser/findList', this.params).then(res => {
        console.log(res);
        this.isTableLoading = false;
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        }
        if(res.status == 201){
          this.$Message.error(res.msg);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询活动用户列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 显示操作模态框
    showUserOpe() {
      /**
       * type判断
       * 1.查看 2.新增 3.编辑
       */
      this.$refs.activityOpe.show();
    },
    // 显示下级用户模态框
    showInvitation(row) {
      this.$refs.inviteeOpe.show(row);
    },
    // 日期条件赋值
    changeDate(e) {
      this.params.startTime = e[0];
      this.params.endTime = e[1];
    },
    // 重置筛选条件
    resetScreen() {
      this.params.nickName = '';
      this.params.isDisable = '';
      this.params.startTime = '';
      this.params.endTime = '';
      this.dateInit = '';
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findList();
    },
    // 显示操作模态框
    showIntegralOpe(row) {
      this.$refs.integralOpe.show(row);
    },
    getActivityAmount() {
      this.axios.post('/activityUser/getActivityAmount').then(res => {
        if (res.status == 200) {
          if (res.data) {
            this.amountData = res.data
          }
        }
        if(res.status == 201){
          this.$Message.error(res.msg);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '禁用用户接口报错',
            duration: 0
          });
        }
      })
    },
    getConfigKey () {
      this.axios.post('/config/findConfigByKey', {configKey: 'activity'}).then(res => {
        if (res.status == 200) {
          if (res.data) {
            this.switch1 = res.data === '1'
          }
        }
        if(res.status == 201){
          this.$Message.error(res.msg);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询配置接口报错',
            duration: 0
          });
        }
      })
    },
    change (status) {
      let configValue = status ? '1' : '0'
      this.axios.post('/config/updateConfigByKey', {configKey: 'activity', configValue: configValue}).then(res => {
        if (res.status == 200) {
          let str = status ? '开启' : '关闭'
          let msg = '已' + str + '全员推广活动';
          this.$Message.info(msg);
        }
        if(res.status == 201){
          this.$Message.error(res.msg);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '修改配置接口报错',
            duration: 0
          });
        }
      })



    }
  },
  components: {
    hsBreadcrumb,
    activityOpe,
    inviteeOpe
  }
}
</script>

<style scoped>

</style>